import { render, staticRenderFns } from "./RegistrationDecisionLoadingPage.vue?vue&type=template&id=34ee0606&scoped=true"
import script from "./RegistrationDecisionLoadingPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationDecisionLoadingPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationDecisionLoadingPage.vue?vue&type=style&index=0&id=34ee0606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ee0606",
  null
  
)

export default component.exports